import React, { cloneElement, useRef, useState } from 'react';

export default function ModalAddEditTask(props) {
  const { open, onClose, children, updateItem } = props;

  const [triggerSubmit, setTriggerSubmit] = useState(false);

  const buttonCloseRef = useRef(null);
  const onCloseModal = () => {
    onClose();
    buttonCloseRef.current.click();
  }
  
  return (
    <div
      className={`modal fade ${open ? 'show' : ''}`}
      style={{ display: open ? 'block' : 'none' }}
      tabIndex="-1"
      role="dialog"
      id="modalAddEditTask" aria-labelledby="modalAddEditTaskLabel" aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="modalAddEditTaskLabel">
                {!updateItem ? "Thêm mới hoạt động" : "Chỉnh sửa hoạt động"}
            </h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
                {open && cloneElement(children, 
                  { ...props,
                    triggerSubmit: triggerSubmit,
                    setTriggerSubmit: setTriggerSubmit,
                    onCloseModal: onCloseModal
                  })
                }
            </div>
          <div className="modal-footer">
            <button
              ref={buttonCloseRef}
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={onCloseModal}
            >
              Đóng
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => setTriggerSubmit(true)}
            >
              Lưu
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}